import { render, staticRenderFns } from "./DetailTablePaymentProvider.vue?vue&type=template&id=7d72da1c"
import script from "./DetailTablePaymentProvider.vue?vue&type=script&lang=js"
export * from "./DetailTablePaymentProvider.vue?vue&type=script&lang=js"
import style0 from "./DetailTablePaymentProvider.vue?vue&type=style&index=0&id=7d72da1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports